import { DocumentBuilder as e } from "./document-builder.js";
import { BlockParser as t } from "./block-parser.js";
//#region src/blocks-parser.ts
var n = class {
	schema;
	constructor(e) {
		this.schema = e;
	}
	parse(n, r) {
		let i = new e(this.schema), a = new t(i, r), o = n.blocks;
		return o.forEach((e, t) => {
			a.handle(e, o[t + 1]);
		}), i.doc;
	}
};
//#endregion
export { n as BlocksParser };
